import { render, staticRenderFns } from "./QuestionTags.vue?vue&type=template&id=d145686e&scoped=true"
import script from "./QuestionTags.vue?vue&type=script&lang=js"
export * from "./QuestionTags.vue?vue&type=script&lang=js"
import style0 from "./QuestionTags.vue?vue&type=style&index=0&id=d145686e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d145686e",
  null
  
)

export default component.exports